import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9052728"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]
const _hoisted_2 = ["xlink:href"]

import { CSSProperties } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSvg',
  props: {
    href: null,
    fontSize: { default: '16px' },
    color: null,
    title: null,
    style: null
  },
  setup(__props: any) {

const props = __props as { href?: string, fontSize: string, color?: string, title?: string, style?: CSSProperties }



return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (__props.title)
    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("svg", {
            class: "icon",
            "aria-hidden": "true",
            style: _normalizeStyle({ ...__props.style, fontSize: __props.fontSize, color: __props.color })
          }, [
            _createElementVNode("use", {
              "xlink:href": `#${__props.href}`
            }, null, 8, _hoisted_1)
          ], 4))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        class: "icon",
        "aria-hidden": "true",
        style: _normalizeStyle({ ...__props.style, fontSize: __props.fontSize, color: __props.color })
      }, [
        _createElementVNode("use", {
          "xlink:href": `#${__props.href}`
        }, null, 8, _hoisted_2)
      ], 4))
}
}

})